import { LinkButton, Page, Icon } from '@webkom/lego-bricks';
import { Plus } from 'lucide-react';
import { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet-async';
import { usePageContext } from 'vike-react/usePageContext';
import { NavigationTab } from '~/components/NavigationTab/NavigationTab';

const BdbOverview = ({ children }: PropsWithChildren) => {
  const pageContext = usePageContext();
  const isCompanyInterest =
    pageContext.urlPathname.includes('company-interest');

  return (
    <Page
      title="Bedriftsdatabase"
      actionButtons={
        isCompanyInterest ? (
          <LinkButton
            key="new-company-interest"
            href="/bdb/company-interest/new"
          >
            <Icon iconNode={<Plus />} size={19} />
            Ny bedriftsinteresse
          </LinkButton>
        ) : (
          <LinkButton key="new-company" href="/bdb/new">
            <Icon iconNode={<Plus />} size={19} />
            Ny bedrift
          </LinkButton>
        )
      }
      tabs={
        <>
          <NavigationTab href="/bdb">Semesterstatuser</NavigationTab>
          <NavigationTab href="/bdb/company-interest">
            Bedriftsinteresser
          </NavigationTab>
        </>
      }
    >
      <Helmet
        title={isCompanyInterest ? 'Bedriftsinteresser' : 'Semesterstatuser'}
      />
      {children}
    </Page>
  );
};

export default BdbOverview;
